<template lang="pug">
	// Calendario
	Overview
</template>

<script>
import Calendario from './calendario.component'
import Overview from './overview.component'
export default {
	components: {
		Calendario,
		Overview
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion-audiovisual/vue/components/overview/mainOverview.component.vue